import React from "react";
import PropTypes from "prop-types";
import {
  TextField,
  FormControl,
  FormLabel,
  InputAdornment,
} from "@mui/material";
import { isMobile } from "react-device-detect";
import checkIcon from "../assets/icons/check-green.svg";
import ClearIcon from '@mui/icons-material/Clear';

const TextFieldInput = ({ field, formik, error, helperText }) => {

  const handleClear = () => {
    if (field?.handleOnChange) {
      // call your custom handler
      field?.handleOnChange(
        { target: { name: field?.name, value: "" } },
        field?.index,
        field?.name,
        null
      );
    } else {
      // fallback to Formik
      formik.setFieldValue(field?.name, "");
    }

    // notify parent if provided
    if (field?.onClear) {
      field.onClear(field?.name);
    }
  }

  return (
    <FormControl fullWidth>
      {field?.label && (
        <FormLabel
          className="form-label"
          htmlFor={field?.name}
          sx={{
            color: "#1C252E",
            fontSize: {
              xs: "13px",
              sm: "13px",
              md: "14px",
              xl: "14px",
            },
            fontWeight: "500",
            lineHeight: "22px",
            mb: "6px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div className="addressProofSpan">
            <div>
              {field?.label}
              {field?.required && <span className="asteriskColor"> *</span>}
            </div>
            <div>
              {field.name === "OCIAlternateDocType" && (
                <span className="checkTermsLabel fontSizeText">
                  &nbsp;(Upload a document with your address proof)
                </span>
              )}
              {field.name === "passportNumber" && (
                <label className="checkTerms fontSizeText">
                  Does your passport have your current address?
                  <input
                    type="checkbox"
                    name="isPassportCurrentAddress"
                    checked={field?.isPassportCurrentAddress}
                    onChange={(e) => {
                      field?.handleOnChange(
                        e,
                        field?.index,
                        "isPassportCurrentAddress",
                        null
                      );
                    }}
                  />
                  <span className="checkmark"></span>
                </label>
              )}
            </div>
          </div>
        </FormLabel>
      )}
      <TextField
        sx={{
          padding: "0",
          border: "0",

          // marginTop: `${field?.label ? "" : "6%"}`,
          "& .MuiOutlinedInput-root": {
            height: field?.multiline ? "auto" : "44px",
            padding: field?.multiline ? "10px 14px" : "10px 14px 10px 0px",
            borderRadius: "8px",
            boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
            fontSize: "14px",
            fontWeight: "400",
            backgroundColor: field?.readonly ? "#f9fafb " : "inherit",
          },
          "& .MuiInputBase-input": {
            height: "100%", // Ensure input field spans full height
            fontSize: isMobile ? "16px" : "14px",
            textTransform:
              field.name === "panNumber" ||
              field.name === "ociNumber" ||
              field.name === "passportNumber" ||
              field.name === "gstNumber"
                ? "uppercase"
                : "initial",
          },
          "& .MuiInputBase-input::placeholder": {
            textTransform: "initial",
            fontSize: "14px",
            color: field?.isDisableField ? "#667085" : "#4F5E71",
            opacity: field?.isDisableField ? 0.4 : 1,
          },
          "& .MuiInputBase-input.Mui-disabled": {
            cursor: "not-allowed",
          },
        }}
        fullWidth
        id={field?.name}
        name={field?.name}
        autoComplete="off"
        placeholder={field?.placeholder || ""}
        type={field?.type || "text"}
        inputProps={{ maxLength: field?.maxLength || 100 }}
        value={
          field?.value === undefined
            ? formik?.values?.[field?.name]
            : field?.value
        }
        onChange={(e) => {
          field?.handleOnChange
            ? field?.handleOnChange(e, field?.index, field?.name, null)
            : formik?.handleChange(e);
        }}
        onBlur={formik?.handleBlur}
        error={
          field?.listKey
            ? formik?.touched?.[field?.listKey]?.[field?.index]?.[
                field?.nameKey
              ] &&
              Boolean(
                formik?.errors?.[field?.listKey]?.[field?.index]?.[
                  field?.nameKey
                ]
              )
            : (formik?.touched?.[field?.name] &&
                Boolean(formik?.errors?.[field?.name])) ||
              error
        }
        helperText={
          field?.listKey
            ? formik?.touched?.[field?.listKey]?.[field?.index]?.[
                field?.nameKey
              ] &&
              formik?.errors?.[field?.listKey]?.[field?.index]?.[field?.nameKey]
            : (formik?.touched?.[field?.name] &&
                formik?.errors?.[field?.name]) ||
              helperText
        }
        InputProps={{
          readOnly: field?.readonly,
          endAdornment: (
            <>
            {field?.showCheckIcon && (
              <InputAdornment position="end">
                <img
                  src={checkIcon}
                  alt="check"
                  style={{ width: 20, height: 20 }}
                />
              </InputAdornment>
            )}
            {field?.showClearIcon && !!formik?.values?.[field?.name] && (
                <InputAdornment position="end">
                  <ClearIcon sx={{ color: '#1A407D', fontSize: 'large', cursor: 'pointer' }} onClick={handleClear} />
                </InputAdornment>
            )}
          </>
          )
        }}
        variant="outlined"
        disabled={field?.readonly}
        multiline={field?.multiline || false} 
        rows={field?.rows || 1}
      />
    </FormControl>
  );
};



TextFieldInput.propTypes = {
  error: PropTypes.any,
  field: PropTypes.any,
  formik: PropTypes.object,
  helperText: PropTypes.any,
};

export default TextFieldInput;
